import { render, staticRenderFns } from "./VPPDetails.vue?vue&type=template&id=6cccc56d&"
import script from "./VPPDetails.vue?vue&type=script&lang=js&"
export * from "./VPPDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports